export type SidebarScreen = 'dialpad' | 'connecting' | 'join' | 'answer' | 'menu' | 'serviceDirectory';

export interface SidebarState {
    screen: SidebarScreen;
}

export const SET_SIDEBAR_SCREEN = 'SET_SIDEBAR_SCREEN';

export interface SetSidebarScreenAction {
    type: typeof SET_SIDEBAR_SCREEN;
    payload: {
        screen: SidebarScreen;
    };
}

export type SidebarActionTypes = SetSidebarScreenAction;
